<mat-toolbar>
  <img src="/assets/img/logo-scolares.webp" alt="Horizon" class="logo" />
  <button class="logout-button" (click)="logout()" data-cy="logout-button">
    <div class="icon-button">
      <mat-icon>exit_to_app</mat-icon>
    </div>
    <div>
      <span class="text-button">Se déconnecter</span>
    </div>
  </button>
</mat-toolbar>